import {isDefined} from "../Value";
import map from "lodash/map";

export default function flatten(errors, fallback)
{
	if (!isDefined(errors) || errors.length === 0)
	{
		return fallback
			? [fallback]
			: ['Es ist ein Fehler aufgetreten'];
	}

	return map(errors, 'message');
}